import { FC, ReactNode } from "react"
import "./styles.scss"

type Props = {
  title: string
  icon: string
  label: string
  cancelClick: () => void
  onClick: () => void
  isModal?: boolean
  // Optional extra action rendered inside the footer bar, before the primary Save pill
  // (e.g. the route page's "Save & Re-optimize" button) so it aligns with Save.
  extraAction?: ReactNode
}

export const UpdateFooter: FC<Props> = ({
  title,
  icon,
  label,
  onClick,
  cancelClick,
  isModal,
  extraAction,
}) => {
  return (
    <div className={`create-household-footer ${isModal ? 'create-household-footer--modal' : ''}`}>
      <div className="create-household-footer__container">
        <div className="create-household-footer__title" onClick={cancelClick}>
          {title}
        </div>
        {extraAction}
        <div className="create-household-footer__icon" onClick={onClick}>
          <img src={icon} alt="save" />
          <label className="create-household-footer__label">{label}</label>
        </div>
      </div>
    </div>
  )
}
